<template lang="pug">
  div.indexBox(v-wechat-title="$route.meta.title=(viewParams.customerInfo.orgName + '：'+businessName)")
    div.navBar
        van-nav-bar(:title="viewParams.customerInfo.orgName + '：'+businessName" left-text='返回' left-arrow fixed @click-left='back')
    van-dropdown-menu.menu(:close-on-click-overlay="false" :close-on-click-outside="false")
        van-dropdown-item(v-model="selectTime" :options="option" @change="changeTime")
        van-dropdown-item(title="自定义条件" ref="item")
          van-cell-group.group
              div(v-if="businessType == 'tcardpay' || businessType == 'addTcard'") 
                div(v-if="businessType == 'tcardpay'")
                  van-field(v-model="noteNo" label="单据号" placeholder="请输入单据号")
                  van-cell(title="消费门店" is-link :value="orgName" @click="onShowOrg")
                  van-cell(title="开始日期" is-link :value="startTime" @click="showTime(0)")
                  van-cell(title="结束日期" is-link :value="endTime" @click="showTime(1)") 
                div(v-if="businessType == 'addTcard'")
                  van-field(v-model="tcardNo" label="次卡卡号" placeholder="请输入次卡卡号")
                  van-cell(title="消费门店" is-link :value="orgName" @click="onShowOrg")
                  van-cell(title="开始日期" is-link :value="startTime" @click="showTime(0)")
                  van-cell(title="结束日期" is-link :value="endTime" @click="showTime(1)") 
              div(v-else)
                  van-field(v-model="noteNo" label="单据号" placeholder="请输入单据号")
                  van-cell(title="消费类型" is-link :value="typeName" @click="onShowType")
                  van-cell(title="消费门店" is-link :value="orgName" @click="onShowOrg")
                  van-cell(title="开始日期" is-link :value="startTime" @click="showTime(0)")
                  van-cell(title="结束日期" is-link :value="endTime" @click="showTime(1)")    
          van-button(block type="info" @click="onConfirm") 确认
    div.payList
        div.payOutItem.van-hairline--bottom(v-for='item in businessList' @click='toPayItem(item)')
            div.payOutLeft
               div.row
                  div.text 单据号：{{item.noteNo}}
                  div.text.rightText {{item.createTime?item.createTime.substr(0,10):''}}
               div(v-if="item.businessType == 'tcardpay' || item.businessType == 'addTcard'") 
                  div(v-if="item.businessType == 'tcardpay'")
                      div.row   
                          div.text 次卡名称：{{item.proName}}
                      div.row
                          div.text 扣卡次数：{{item.thisCounts}}
                          div.text.rightText 余额：{{item.newCounts}}
                  div(v-if="item.businessType == 'addTcard'")
                      div.row   
                          div.text 购买名称：{{item.proName}}
                      div.row
                          div.text 此卡次数：{{item.thisCounts}}
                          div.text.rightText 余次：{{item.newCounts}}
               div(v-else)  
                  div.row   
                      div.text 项目名称：{{item.proName}}
                  div.row
                      div.text 实收金额：{{item.realAmount}}
                      div.text.rightText 余额：{{item.maCustomerBusinessRecord?item.maCustomerBusinessRecord.newAmount:''}}
            div.payOutRight
               van-icon(name="arrow" style="line-height: inherit;padding:3px 0 0 3px;" size="18") 
    div.tools
       div.btns
          van-button.btn( plain type="primary" @click='toPage(-1)') 上一页
          div {{current}}/{{total}}
          van-button.btn( plain type="primary" @click='toPage(1)') 下一页  
    van-popup(v-model="show" position="bottom")
        van-datetime-picker(v-model="currentDate" type="date" @confirm="confirm" @cancel="cancel")
    van-action-sheet(v-model="showType" :actions="types" @select="onSelect" cancel-text="取消" @cancel="onCancel") 
    van-action-sheet(v-model="showOrg" :actions="orgs" @select="onSelectOrg" cancel-text="取消" @cancel="onCancel") 
</template>

<script>
  import { NavBar, Button, Toast, Icon, Cell, CellGroup,DropdownMenu, DropdownItem, Field, Popup, DatetimePicker,ActionSheet } from 'vant';
  import { mapGetters,mapMutations } from 'vuex';
  import svgIcon from './common/icon';

  export default {
    components: {
      'svgIcon':svgIcon,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [Icon.name]: Icon,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [DropdownMenu.name]:DropdownMenu,
      [DropdownItem.name]:DropdownItem,
      [Field.name]:Field,
      [Popup.name]:Popup,
      [DatetimePicker.name]:DatetimePicker,
      [ActionSheet.name]:ActionSheet,
      [NavBar.name]: NavBar
    },
    name: 'login',
    created() {
      this.orgs = [{name:this.viewParams.shopInfo.ORGNAME,value:this.viewParams.shopInfo.ORGID}]
      this.businessType = this.$route.query.businessType;
      if(this.businessType == 'tcardpay'){
          this.businessName = '扣次卡消费记录';
      }else if(this.businessType == 'addTcard'){
          this.businessName = '购买次卡记录';
      }else{
          this.businessName = '储值卡消费记录';
      }
      this.showBusinessList();
    },
    computed: {
      ...mapGetters([
        'viewParams'
      ])
    },
    data() {
      return {
        selectTime: 0,
        userName: '',
        option: [
          { text: '全部时间', value: 0 },
          { text: '本周', value: 1 },
          { text: '本月', value: 2 },
        ],
        businessList:[],
        businessType:'',
        current:1,
        total:1,
        businessName:'',
        show:false,
        currentDate:new Date(),
        startTime:'',
        endTime:'',
        timeType:'',
        noteNo:'',
        tcardNo:'',
        showType:false,
        types:[
            {name:'购卡消费',value:'addCard'},
            {name:'卡升级消费',value:'upgrade'},
            {name:'积分兑换',value:'score2object'},
            {name:'一般消费',value:'pay'},
            {name:'数据导入',value:'imp'},
            {name:'积分清零',value:'cleanPoints'},
            {name:'充值消费',value:'recharge'},
            {name:'购买次卡',value:'addTcard'},
            {name:'次卡消费',value:'tcardpay'}
        ],
        type:'',
        typeName:'',
        showOrg:false,
        orgs:[],
        orgId:'',
        orgName:'',
      };
    },
    methods:{
      back() {
        this.setTransition('move-right');
        this.$router.go(-1);
      },
      onConfirm() {
        this.$refs.item.toggle();
        this.showBusinessList();
      },
      changeTime(){
        this.startTime = '';
        this.endTime = '';
        this.noteNo = '';
        this.tcardNo = '';
        this.type = '';
        this.typeName = '';
        this.orgId = '';
        this.orgName = '';
        this.showBusinessList();
      },
      showTime(type){
        this.timeType = type;
        this.show = true;
      },
      confirm(value){
        this.show = false;
        if(this.timeType == 0){
          this.startTime = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
        }
        if(this.timeType == 1){
          this.endTime = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
        }
      },
      onSelect(item){
        this.showType = false;
        this.type = item.value;
        this.typeName = item.name;
      },
      onSelectOrg(item){
        this.showOrg = false;
        this.orgId = item.value;
        this.orgName = item.name;
      },
      onShowType(){
        this.showType = true;
      },
      onShowOrg(){
        this.showOrg = true;
      },
      onCancel(){
        this.type = '';
        this.typeName = '';
        this.orgId = '';
        this.orgName = '';
      },
      cancel(){
        this.show = false;
        if(this.timeType == 0){
          this.startTime = '';
        }
        if(this.timeType == 1){
          this.endTime = '';
        }
      },
      toPage(diff){
        if(diff < 0 && this.current > 1){
          this.current = this.current + diff;
        }

        if(diff > 0 && this.current < this.total){
          this.current = this.current + diff;
        }
        this.showBusinessList();
      },
      toPayItem(item){
        this.saveViewParams({'shopInfo':this.viewParams.shopInfo,'customerInfo':this.viewParams.customerInfo,'payItem':item});
        this.$router.push('/payItem');
      },
      showBusinessList(){
        Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner'
        });
        this.$http.post('/business/showBusinessList', {
            'customerId':this.viewParams.customerInfo.fkCustomerId,
            'businessType': this.businessType,
            'current':this.current,
            'selectTime':this.selectTime,
            'noteNo':this.noteNo,
            'tcardNo':this.tcardNo,
            'startTime':this.startTime,
            'endTime':this.endTime,
            'type':this.type,
            'orgId':this.orgId
          }).then((response) => {
            Toast.clear();
            if (response.data.success) {
                this.current = response.data.content.current;
                this.total = response.data.content.pages;
                let businessList = response.data.content.records;
                businessList.forEach(item=>{
                  if(item.maCustomerCountsRecords){
                    item.thisCounts = 0;
                    item.newCounts = 0;
                    item.maCustomerCountsRecords.forEach(itemRecord=>{
                      item.thisCounts = item.thisCounts + itemRecord.thisCounts;
                      item.newCounts = item.newCounts + itemRecord.newCounts;
                    })
                  }
                });
                this.businessList = businessList;
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      ...mapMutations([
        'saveViewParams',
        'setTransition'
      ])
    }
  };
</script>

<style lang="less" scoped>
  .indexBox{
    background-color: rgb(246, 247, 248);
    overflow:scroll;
    overflow-y:hidden;
    overflow-x:hidden;
    min-height: 100%;
    .group{
        margin: 10px 0 50px;
    }
    .menu{
      margin-top: 50px;
    }
    .payList{
      background-color: white;
      .payOutItem{
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        .payOutLeft{
          text-align: left;
          display: flex;
          flex-direction: column;
          .row{
            display: flex;
            text-align: left;
            align-items: center;
            justify-content: space-between;
            padding: 2px 0;
            .text{
              font-size: 15px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              width: 250px;
            }
            .rightText{
               width: 100px;
            }
          } 
        }
        .payOutRight{
            text-align: right;
            height: 40px;
            width: 30px;
            display: flex;
            color: #969799;
            font-size: 14px;
            padding-right: 15px;
        }
      }
    }
    .tools{
      margin: 20px 0;
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      background: white;
      padding: 10px 0;
      .btns{
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: space-between;
        width: 300px;
        .btn{
           width: 100px;
           height: 40px;
           line-height: 40px;
           border-radius:6px;
        }
      }
    }
  }
</style>